export enum RoleEnum {
  'MANAGER' = 'Gerente',
  'ASSISTANT_MANAGER' = 'Sub-gerente',
  'SELLER' = 'Consultor',
}
